import type { FC } from "react";
import { Link } from "react-router-dom";

import { Button } from "@/components/flexkit/Button";
import { Heading3 } from "@/components/flexkit/typography/Headings";
import { Text } from "@/components/flexkit/typography/Text";

type Props = {
    title: string;
    description: string;
    action: string;
    disabled?: boolean;
    to?: string;
    onClick?: () => void;
};
export const TierUpgradeTile: FC<Props> = ({ title, description, action, onClick, disabled, to }) => {
    return (
        <div className="flex w-full items-center justify-between gap-2 rounded-xl border-2 border-border-base bg-surface-01 p-5">
            <div>
                <Heading3 className="text-xl font-normal text-content-primary">{title}</Heading3>
                <p className="max-w-56 text-base font-normal text-content-primary">{description}</p>
            </div>
            {disabled ? (
                <Text className="text-base font-normal text-content-primary">{action}</Text>
            ) : (
                <Button
                    variant={"secondary"}
                    className="text-base font-normal text-content-primary"
                    onClick={onClick}
                    disableTracking
                    asChild={!!to}
                >
                    {to ? (
                        <Link to={to} className="text-base font-normal text-content-primary">
                            {action}
                        </Link>
                    ) : (
                        <Text className="text-base font-normal text-content-primary">{action}</Text>
                    )}
                </Button>
            )}
        </div>
    );
};
